import React, {Component} from 'react';
import {Button, List} from 'semantic-ui-react';

class ShoppingItem extends Component {

    render() {
        return (
            <List.Item>
                <List.Content floated='right'>
                        <Button primary onClick={()=>this.props.callbackClick({id:this.props.id, type:this.props.type})} icon='angle right'></Button>
                </List.Content>
                <List.Content verticalAlign='middle'>
                    <List.Header as='h4'>{this.props.name}</List.Header>
                    <List.Description>
                        {this.props.count_stock} unidades disponibles
                    </List.Description>
                </List.Content>
            </List.Item>
        );
    }
}

export default ShoppingItem;



// WEBPACK FOOTER //
// ./src/components/inventories/ShoppingItem.js